module.exports = __webpack_public_path__ + "static/media/composition.7424ce42.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/composition.gif
// module id = 433
// module chunks = 0